import React from 'react';
import Component from '../../../Component';
import { withResizer, withTranslations } from '../../../../HoCs';
import Revenue from '../../../../Modules/LandingPageNew/LandingSubComponents/Revenue';
import Styles from './styles';
import Network from '../../../../services/Network';
import { debounce } from '../../../../utils/functionUtils';
import { FETCH_LOCATION,GET_EARNING_POTENTIAL } from '../../../../utils/endpoints';
import { path } from '../../../../utils';
import DropdownMenuLocation from '../../../../common/DropDownLocation';
import { borders, validation } from '../../../../Enums';
import ClickAwayListener from '@material-ui/core/ClickAwayListener/ClickAwayListener';
import { bindActionCreators } from 'redux';
import * as GlobalActions from '../../../../reducers/actions';
import { connect } from 'react-redux';
import view from '../../../../Enums';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../../../services/Analytics';

class RevenueMigrationWrapper extends Component {
    
    styles = Styles;
    
    state = {
        amount:null,
        city:'',
        locationText:'',
        location:null,
        locationDropdownOptions:[],
        showDropdown:true,
        location_border: borders.NORMAL_BORDER,
        location_border_validated:true,
        revenueLoader:false
    };
    
    onLocationTextUpdate = (e) => {
        let val = e.target.value;
        this.setState({locationText:val});
        this.getLocationSuggestions(val)
    };
    
    getLocationSuggestions = debounce((text) => {
        
        let country_code = this.props.globalData.locale.toUpperCase();
        if (country_code === 'UK') country_code = 'GB';
        
        Network.GET(FETCH_LOCATION,{
            query:text,
            region:country_code
        },null,this.onLocationFetchResult)
    },200);
    
    onLocationFetchResult = (obj) => {
        this.setState({
            showDropdown:true,
            locationDropdownOptions:path(obj,'responseObject',[])
        })
    
    };
    
    validateOneField = field => {
        // validate location
        switch(field){
            case validation.REVENUE_POTENTIAL:
                if (
                    !this.props.globalData.earning_potential_data.noDataForCity &&
                    this.props.globalData.earning_potential_data.data.length == 0
                ) {
                    this.setState({ location_border_validated: false });
                    return false;
                } else {
                    return true;
                }
            case validation.LOCATION_OBJECT:
                if (Object.keys(this.props.globalData.selected_location).length == 0) {
                    this.setState({ location_border_validated: false });
                    return false;
                } else {
                    this.setState({ location_border_validated: true });
                    return true;
                }
        }
        
    };
    
    onClickDropdown = (obj) => {
    
        this.setState({
            showDropdown: false,
            locationDropdownOptions: [],
            selectedLocation: obj,
            location_border_validated: true
        });
        
        let countryId, cityId;
        if (obj.country) countryId = obj.country.id;
        if (obj.city) {
            cityId = obj.city.id;
            this.props.globalActions.getEarningPotential(countryId, cityId);
        } else {
            // Pre empt response
            this.setState({amount:null})
        }
        
        this.setState({locationText:obj.displayName});
        
    };
    
    getEarningPotential = (countryId, cityId) => {
        this.setState({amount:null,revenueLoader:true})
        Network.GET(GET_EARNING_POTENTIAL,{
            country_id:countryId,
            city_id: cityId
        },null,this.earningPotentialSuccess,this.earningPotentialError)
    };
    
    earningPotentialSuccess = (obj) => {
    
    };
    
    earningPotentialError = (error) => {
    
    };
    
    render() {
        return (
            <div style={this.gs('revenue_parent')}>
                
                <div style={this.gs('heading')}>{this.guc('enter_city')}{':'}</div>
                
                <div style={{
                    position:'relative',
                    width: '-webkit-fill-available',
                    margin: '0px 7px'
                }} >
                <input
                    value={this.state.locationText}
                    placeholder={this.guc('please_enter_city')}
                    style={{...this.gs('city_input'),
                        border: this.state.location_border_validated
                        ? this.state.location_border
                        : borders.RED_BORDER}}
                    type="text"
                    autoComplete="new-password"
                    className={'removeFocusOutline'}
                    onChange={this.onLocationTextUpdate}
                    onFocus={() => {
                        this.setState({
                            location_border: borders.ACTIVE_BORDER
                        });
                    }}
                    onBlur={() => {
                        this.setState({
                            location_border: borders.NORMAL_BORDER
                        });
                    }}
                />
                    <ClickAwayListener
                        onClickAway={() => {
                            this.setState({ showDropdown: false })
                        }}
                    >
                        <div>
                            {this.state.showDropdown && (
                                <DropdownMenuLocation
                                    options={this.state.locationDropdownOptions}
                                    style={{}}
                                    change={this.onClickDropdown}
                                />
                                
                            )}
                        </div>
                    </ClickAwayListener>
                </div>
                
                <Revenue
                    validateOneField={this.validateOneField}
                    amount={this.amount}
                    viewMode={this.getViewMode()!=view.TAB?this.getViewMode():view.MOBILE}
                    eventCategory={EVENT_CATEGORIES.HEADER}
                    eventAction={EVENT_ACTIONS.ROOM_COUNT_ENTERED}
                />
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        globalActions: bindActionCreators(GlobalActions, dispatch)
    };
};

const mapStateToProps = state => {
    return {
        globalData: state.globalReducer
    };
};


export default connect(mapStateToProps,mapDispatchToProps)(withTranslations(withResizer(RevenueMigrationWrapper)));